export default __webpack_public_path__ + "static/media/717.a967d8ed.png";